import { ResponsiveRow } from 'src/components/common/ResponsiveRow';
import { FlexBoxColumn } from 'src/components/common/FlexBoxColumn';
import {alpha, Button, Typography, useMediaQuery} from '@mui/material';
import { BodyXLarge } from './KeyTakeAway';
import { LyraTheme as theme } from 'src/components/theme/lyra/Theme';
import { FlexBoxRow } from 'src/components/common/FlexBoxRow';
import { useTranslation } from 'react-i18next';

import useGATracking from 'src/hooks/google/useGATracking';
import SharpenedLogoArrowDesktop from 'src/assets/websitegrader/footer/SharpenedLogoArrowDesktop.svg';
import SharpenedLogoArrowMobile from 'src/assets/websitegrader/footer/SharpenedLogoArrowMobile.svg';

export const Footer = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation(['websiteGrader']);
  const { pushCustomGAEvent } = useGATracking({ triggerOnMount: false });

  const handleLetsTalkButtonClick = () => {
    pushCustomGAEvent({
      gaEventCategory: 'WebsiteGrader',
      gaEventAction: 'Click',
      gaEventLabel: 'WebsiteGraderLetsTalk',
      buttonId: 'website-grader-button-lets-talk'
    });

    // Redirect to the external URL
    window.location.href = t('footer.letsTalkUrl');
  };

  return (
    <ResponsiveRow
      id="website-grader-footer"
      sx={{
        gap: isMobile ? 5 : 0,
        borderRadius: '12px',
        justifyContent: 'flex-start',
        background: 'rgba(218, 228, 255, 0.40)',
        alignSelf: 'stretch',
        p: isMobile ? '40px 16px 24px 16px' : 0,
      }}
    >
      <FlexBoxRow sx={{ flex: '1 0 30%', justifyContent: 'flex-start' }}>
        <img
          src={isMobile ? SharpenedLogoArrowMobile : SharpenedLogoArrowDesktop}
          width={isMobile ? '136px' : '336px'}
          alt="Sharpened-Arrow-Pointing-Up-Icon"
        />
      </FlexBoxRow>
      <FlexBoxColumn
        sx={{
          flex: '10 0 0',
          alignItems: 'flex-start',
          gap: 2,
          paddingY: isMobile ? 0 : 7,
          paddingX: isMobile ? 0 : 7,
        }}
      >
        <Typography variant="h5">{t('footer.localiqWebsites')}</Typography>
        <Typography variant="h3">{t('footer.weCanHelp')}</Typography>
        <BodyXLarge>{t('footer.helpDescription')}</BodyXLarge>
        <Button
          id='website-grader-button-lets-talk'
          variant="contained"
          color="primary"
          sx={{
            fontSize: isMobile ? 14 : 20,
            fontWeight: 600,
            borderRadius: '12px',
            height: 40,
            padding: isMobile
              ? `${theme.spacing(1.25)} ${theme.spacing(2.5)}`
              : `${theme.spacing(2)} ${theme.spacing(3)}`,
            textTransform: 'initial',
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.88),
            },
            '&:active': {
              backgroundColor: alpha(theme.palette.primary.main, 0.80),
            },
          }}
          onClick={handleLetsTalkButtonClick}
        >
          {t('footer.letsTalk')}
        </Button>
      </FlexBoxColumn>
    </ResponsiveRow>
  );
};
